import { v4 } from "uuid";

import { OfferDto } from "@intelligems/ig-types";
import { DISCOUNT_MAX_UNITS } from "@src/api/initials";

export const offerExample: OfferDto = {
  id: v4(),
  enabled: false,
  isTest: false,
  variationId: v4(),
  name: "Discount Progress Bar",
  unitType: "unit",
  discountType: "percentage",
  discountApplicationType: "",
  discountApplicationMethod: "perItem",
  combinesWithIntelligems: false,
  combinesWithShopify: false,
  shouldRejectCodes: false,
  tiers: [
    {
      id: "1",
      minimumUnits: 2,
      maximumUnits: 3,
      unitDiscount: 0,
      discountTitle: null,
      giftWithPurchaseTitle: null,
      isFreeShipping: true,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: false,
    },
    {
      id: "2",
      minimumUnits: 5,
      maximumUnits: 6,
      unitDiscount: 10,
      discountTitle: null,
      giftWithPurchaseTitle: null,
      isFreeShipping: false,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: false,
    },
    {
      id: "3",
      minimumUnits: 8,
      maximumUnits: DISCOUNT_MAX_UNITS,
      unitDiscount: 0,
      discountTitle: null,
      giftWithPurchaseTitle: null,
      isFreeShipping: false,
      isGiftWithPurchase: true,
      autoAddGiftWithPurchase: true,
    },
  ],
  isArchived: false,
  maximumDollarDiscount: null,
  shippingDiscount: null,
};

export const exampleShippingOffer: OfferDto = {
  id: v4(),
  enabled: false,
  isTest: false,
  variationId: v4(),
  name: "Shipping Progress Bar",
  unitType: "dollar",
  discountType: "percentage",
  discountApplicationType: "",
  discountApplicationMethod: "perItem",
  combinesWithIntelligems: false,
  combinesWithShopify: false,
  shouldRejectCodes: false,
  tiers: [
    {
      id: v4(),
      minimumUnits: 50,
      maximumUnits: DISCOUNT_MAX_UNITS,
      unitDiscount: 5,
      discountTitle: null,
      giftWithPurchaseTitle: null,
      isFreeShipping: true,
      isGiftWithPurchase: false,
      autoAddGiftWithPurchase: true,
    },
  ],
  isArchived: false,
  maximumDollarDiscount: null,
  shippingDiscount: null,
};
